<template>
  <div id="app">
    <div class="menu-box" v-if="screenWidth>750">
      <div class="log-box">
        <img src="@/assets/logo.png" alt="">
        <span>Pesokwento</span>
      </div>
      <div class="menu-item">
        <div @click="choiceMenu(0)" :class="(menuIndex===0)?'choice':''">Home</div>
        <div @click="choiceMenu(1)" :class="(menuIndex===1)?'choice':''">Product</div>
        <div @click="choiceMenu(2)" :class="(menuIndex===2)?'choice':''">How it works</div>
        <div @click="choiceMenu(3)" :class="(menuIndex===3)?'choice':''">Advantages</div>
        <div @click="choiceMenu(4)" :class="(menuIndex===4)?'choice':''">About Us</div>
        <div @click="choiceMenu(5)" :class="(menuIndex===5)?'choice':''">Privacy Policy</div>
      </div>
    </div>
    <div class="banner-box" id='home' ref="home">
      <swiper :options="pagination">

        <swiper-slide>
          <img src="../assets/banner-2.png" class="banner">
        </swiper-slide>
        <swiper-slide>
          <img src="../assets/banner-3.png" class="banner">
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
    <div id='step_1' ref="step_1"></div>
    <div class="content-box">
      <div class="flex-box">
        <div class="text-box">
          <div class="text-1">Product features</div>
          <div class="text-2"> Pesokwento is a small loan designed to solve the occasional financial dilemma of modern life, allowing users to apply for loans based on their needs. </div>
          <!-- <div class="text-3">Download The App</div> -->
        </div>
        <img src="@/assets/step_1.png" class="step_1">
      </div>
    </div>
    <div id='step_2' ref="step_2"></div>
    <div class="content-box">
      <div class="flex-box">
        <img src="@/assets/step_2.png" class="step_1">
        <div class="text-box right-box">
          <div class="text-1">Product advantages</div>
          <div class="text-2">
            Flexible credit limit, users can choose freely. <br>
            Online review, eliminating the need for a complicated application process.<br>
            High approval rate, solving your financial problems.

          </div>
          <!-- <div class="text-3">Check Eligibility</div> -->
        </div>
      </div>
    </div>
    <div id='step_3' ref="step_3"></div>
    <div class="list-box">
      <div class="title">Our story</div>
      <div class="text">Pesokwento is dedicated to helping ordinary people with their short term financial problems. We currently serve 100,000+ users, helping them when they need money urgently for medical, educational and other issues.</div>
      <div class="list-flex">
        <div class="info-box">
          <img src="@/assets/list-1.png" class="list-img">
          <div class="info-title">Online application</div>
          <div class="info-text">Users only need to fill in the information online and then apply for the loan, eliminating the need for a cumbersome offline process and saving time for users</div>
          <!-- <div class="pay">Pay Now </div> -->
        </div>
        <div class="info-box">
          <img src="@/assets/list-2.png" class="list-img">
          <div class="info-title">Loans with a track record</div>
          <div class="info-text">Every loan you apply for will generate an order number and be displayed in the app, so you can check your information at any time</div>
          <!-- <div class="pay">Pay Now </div> -->
        </div>
        <div class="info-box">
          <img src="@/assets/list-3.png" class="list-img">
          <div class="info-title">Multiple payment options</div>
          <div class="info-text">A wide range of payment options are available to serve you wholeheartedly!</div>
          <!-- <div class="pay">Pay Now </div> -->
        </div>
      </div>
    </div>
    <div id='step_4' ref="step_4"></div>
    <div class="list-box">
      <div class="title">Loan application process</div>
      <!-- <div class="text">An Instant Loan is a kind of personal loan that involves minimum documentation, quick approval, and a relatively simple application process. The best part about applying for an instant loan is that it saves you valuable time as you don’t need to visit a bank or fill out lengthy documents. So, the next time you’re in need of funds for a wedding party</div> -->
      <div class="list-flex">
        <img src="@/assets/step_3.png" class="step_3">
        <div class="step-box">
          <div class="step-title">Your Reliable Financial Partner at your fingertips.</div>
          <div class="quick-easy-box">
            <div>Quick and Easy</div>
            <p>Download the app and apply for a loan in less than 5 minutes.</p>
          </div>
          <div class="setps">
            <ul>
              <!-- 第一步 -->
              <li>
                <div data-attr="Fill in personal information"></div>
              </li>
              <li>
                <div data-attr="apply for loan"></div>
              </li>
              <li>
                <div data-attr="wait for approval "></div>
              </li>
              <li>
                <div data-attr="get the money"></div>
              </li>
            </ul>
          </div>
        </div>

      </div>
    </div>
    <div id='step_5' ref="step_5"></div>
    <div class="content-box">
      <div class="flex-box">
        <div class="text-box">
          <div class="text-1">What we can bring to our users</div>
          <div class="text-2">We all face troughs and we want to be a light in your troubled times. Our wish is simple: no more poverty and hardship, and we hope that our funds will help you get out of it.</div>
          <!-- <div class="text-3">Download The App</div> -->
        </div>
        <img src="@/assets/step_4.png" class="step_1">
      </div>
    </div>
    <div id='step_6' ref="step_6"></div>
    <div class="privacy-box">
      <a href="/privacy">
        <div class="content">
          <div class="title">Privacy Policy</div>
          <div class="text">Go to Privacy Policy >></div>
        </div>
      </a>
    </div>
    <div class="del-data-box">
      <div class="tel-box" v-if="steps == 1">
        <div class="tip">
          Using the data deletion function, for the security of your data, you need to verify your identity
        </div>
        <div class="title">Please enter your mobile number</div>
        <input
          v-model="mobile"
          type="text"
          class="tel-in"
          placeholder="Please enter a telephone number"
        />
        <input
          v-model="password"
          type="password"
          class="tel-pa"
          placeholder="Please enter the APP password"
        />
        <div class="btn" @click="delSearch">Next step</div>
      </div>
      <div class="tel-box" v-else-if="steps == 2">
        <div class="text-box">
          Dear user <br>
          Thank you very much for your continued support and encouragement to us. We respect and protect your privacy and understand your demands for information security. Therefore, we insist on providing the account deletion function to meet your needs and protect your data. <br>
          Please confirm that all your orders have been settled before deleting the account, otherwise the account will not be deleted.
          It should be emphasized that once the account is deleted, the data cannot be recovered. If you want to continue to use this application, you need to register again. Please operate with caution.
        </div>
        <div class="btn" @click="candelete">confirm delete</div>
      </div>

      <div class="tel-box" v-else-if="steps == 3">
        <div class="title">
          Please enter the verification code to verify your identity
        </div>
        <div class="iump-box">
          <input
            v-model="code"
            type="text"
            class="car-in tel-in"
            placeholder="Please enter the 4 digit verification code"
          />
          <div class="count-btn" @click="Reenviar">
            {{ Time <= 0 ? "Resend" : Time }}
          </div>
        </div>
        <div class="btn" @click="doDelete">Okay</div>
      </div>
      <div class="tel-box del-box" v-else-if="steps == 4">
        <img src="../assets/del.png" alt="" />
        <p>Your data has been deleted!</p>
      </div>
      <div class="tel-box" v-else-if="steps == 5">
        <div class="title">Identity card verification</div>
        <input
          v-model="idcard"
          type="text"
          class="tel-in"
          placeholder="Please enter your ID Number"
        />
        <div class="btn" @click="verifyIdCard">Inspect</div>
      </div>

      <div class="flex-box-delete" v-if="msgDlg">
        <div class="msg-box">
          <div class="msg">
            <img src="../assets/title-err.png" class="err-img" />
            {{ msg }}
          </div>
          <img
            src="../assets/close.png"
            class="close"
            @click="msgDlg = false"
          />
        </div>
      </div>
    </div>
    <div id='step_7' ref="step_7"></div>
    <div class="foot-box">
      <div class="flex-footer-content">
        <div class="box">
          <img src="@/assets/mail.png" class="mail-img">
          <div class="text">dfd345gh@gmail.com.</div>
        </div>
        <div class="box">
          <img src="@/assets/address.png" class="mail-img">
          <div class="text">Unit 1907 The Trade and Financial Tower. 7th Ave. cor.32nd St., Brgy. Fort Bonifacio, Taquiq City 1634, Philippines</div>
        </div>
      </div>
    </div>
    <div class="copyright">© Copyright by Pesokwento.</div>

  </div>
</template>

<script>
import privacy from "@/components/privacy";
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
// import "swiper/swiper.min.css";
// import 'swiper/css'
import 'swiper/css/swiper.min.css'
import * as api from "@/api/api";
export default {
  name: 'App',
  components: {
    privacy,
    Swiper,
    SwiperSlide,
    directive
  },
  data () {
    return {
      isMore: false,
      menuIndex: 0,
      screenWidth: document.body.clientWidth,
      showMenu: false,
      content: '1',
      pagination: {
        autoplay: true,
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true
        },
      },
      mobile: "",
      password: "",
      code: "",
      msgDlg: false,
      msg: "",
      steps: 1,
      infoData: {},
      Time: 0,
      idcard: "",
      verifyIDCard: "",
    }
  },
  mounted () {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
    let item = this.$route.query.item
    console.log(item);
    if (item == 'partners') {
      this.$nextTick(() => {
        setTimeout(() => {
          this.choiceMenu(6)
        }, 1000);
      })
    }
  },
  methods: {
    choiceMenu (index) {
      this.menuIndex = index
      setTimeout(() => {
        this.showMenu = false
      }, 100);
      switch (index) {
        case 0: document.getElementById("home").scrollIntoView(); break;
        case 1: document.getElementById("step_1").scrollIntoView(); break;
        case 2: document.getElementById("step_2").scrollIntoView(); break;
        case 3: document.getElementById("step_3").scrollIntoView(); break;
        case 4: document.getElementById("step_4").scrollIntoView(); break;
        case 5: document.getElementById("step_5").scrollIntoView(); break;
        case 6: document.getElementById("step_6").scrollIntoView(); break;
        case 7: document.getElementById("step_7").scrollIntoView(); break;
        default:
          break;
      }
    },
    menuClick () {
      this.showMenu = !this.showMenu
    },
    delSearch() {
      let data = {
        mobile: this.mobile,
        password: this.password,
      };
      console.log(this.$loading);
      let loding = this.$loading.show({});
      api
        .delInfoSearch(data)
        .then((res) => {
          loding.hide();
          this.infoData = res.data;
          this.steps = 2;
        })
        .catch((e) => {
          loding.hide();
          this.msgDlg = true;
          this.msg = e.message;
        });
    },
    candelete() {
      let data = {
        user_id: this.infoData.user_id,
      };
      let loding = this.$loading.show({});
      api
        .delInfoCanDelete(data)
        .then((res) => {
          loding.hide();
          if (res.data.idcard) {
            this.verifyIDCard = res.data.idcard;
            this.steps = 5;
          } else {
            this.steps = 3;
            this.Reenviar();
          }
        })
        .catch((e) => {
          loding.hide();
          this.msgDlg = true;
          this.msg = e.message;
        });
    },
    verifyIdCard() {
      console.log(this.verifyIDCard);
      if (this.verifyIDCard == this.idcard) {
        this.steps = 3;
        this.Reenviar();
      } else {
        this.msgDlg = true;
        this.msg = "Kartu ID yang dimasukkan salah dan verifikasi gagal.";
      }
    },
    Reenviar() {
      if (this.Time > 0) {
        return;
      }
      this.Countdown(60);
      let data = {
        mobile: this.mobile,
      };
      let loding = this.$loading.show({});
      api
        .delInfoSms(data)
        .then((res) => {
          loding.hide();
        })
        .catch((e) => {
          loding.hide();
          this.msgDlg = true;
          this.msg = e.message;
        });
    },
    doDelete() {
      let loding = this.$loading.show({});
      let data = {
        mobile: this.mobile,
        code: this.code,
        user_id: this.infoData.user_id,
      };
      api
        .delInfoDoDelete(data)
        .then((res) => {
          loding.hide();
          this.steps = 4;
        })
        .catch((e) => {
          loding.hide();
          this.msgDlg = true;
          this.msg = e.message;
        });
    },
    Countdown(time) {
      this.Time = time;
      if (time <= 0) {
        return;
      }

      setTimeout(() => {
        this.Countdown(time - 1);
      }, 1000);
    },
  
  }
}
</script>


<style lang="less" >
@import url('@/style/m_index.less') only screen and (max-width: 750px);
@import url('@/style/pc_index.less') only screen and (min-width: 750px);
</style>
